import { IconProps } from ".";

export const LightningBoltIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3066 3.4124L4.61163 12.6341C4.13391 13.2919 4.60385 14.2133 5.41627 14.2133H10.8931V20.0033C10.8931 20.9666 12.1278 21.3684 12.694 20.5871L19.389 11.3664C19.8667 10.7086 19.3968 9.78627 18.5843 9.78627H13.1066V3.99715C13.1066 3.03295 11.8728 2.63209 11.3066 3.4124Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
